import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const studentCreditsService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-credits/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching student credits list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/student-credits/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById student credits", error);
            throw error;
        }
    },

    async save(student: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-credits/save`,
                student
            );
            return response.data;
        } catch (error) {
            console.error("Error save student credits", error);
            throw error;
        }
    },

    async deleteById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/student-credits/deleteById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById student credits", error);
            throw error;
        }
    },

    async uploadStudentCredits(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-credits/upload-student-credits`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save student credits", error);
            throw error;
        }
    },
}

export default studentCreditsService;